import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProaService } from '../processos/services/proa.service';
import { MaskService } from 'src/app/shared/services/mask.service';

@Component({
  selector: 'app-detalhe-projeto-ircp-proa-list',
  templateUrl: './detalhe-projeto-ircp-proa-list.component.html',
  styleUrls: ['./detalhe-projeto-ircp-proa-list.component.scss']
})
export class DetalheProjetoIrcpProaListComponent extends BaseListComponent<any> implements OnInit, OnDestroy {
  @Input() idProjeto: number;
  @Input() idIrcp: number;
  lista: any[];
  showSituacao: any = [];

  constructor(
    private myService: ProaService,
    private maskService: MaskService
  ) {
    super();
  }

  ngOnInit() {
    this.addSub(
      this.myService.listProcess(this.idProjeto, {tipo_vinculacao: 4, item_id: this.idIrcp}).subscribe((res) => {
        this.lista = res;
        this.loaded();
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  verSituacaoClickHandler(key: any): void {
    if (this.showSituacao[key]) {
      this.showSituacao[key] = !this.showSituacao[key];
    } else {
      this.showSituacao[key] = true;
    }
  }
  
  onMaskProcesso(valor: string): string{
    return this.maskService.mascaraProcesso(valor);
  }
}